import { isProductAttributeCode } from "../config";
import type { SelectedAttributes } from "../types";

export const FILTER_PARAM_PREFIX = "attribute_";

const toParams = (search: string | URLSearchParams): URLSearchParams =>
  typeof search === "string" ? new URLSearchParams(search) : new URLSearchParams(search.toString());

export const parseAttributeParams = (search: string | URLSearchParams): SelectedAttributes => {
  const params = toParams(search);
  const selected: SelectedAttributes = {};

  params.forEach((raw, key) => {
    if (!key.startsWith(FILTER_PARAM_PREFIX)) return;

    const code = key.slice(FILTER_PARAM_PREFIX.length);
    if (!isProductAttributeCode(code)) return;

    const values = raw
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean);

    if (values.length > 0) {
      selected[code] = values;
    }
  });

  return selected;
};

export const serializeAttributeParams = (
  selected: SelectedAttributes,
  currentSearch: string | URLSearchParams
): URLSearchParams => {
  const params = toParams(currentSearch);

  [...params.keys()].filter((key) => key.startsWith(FILTER_PARAM_PREFIX)).forEach((key) => params.delete(key));

  Object.entries(selected).forEach(([code, values]) => {
    if (isProductAttributeCode(code) && values && values.length > 0) {
      params.set(`${FILTER_PARAM_PREFIX}${code}`, values.join(","));
    }
  });

  return params;
};

export const getSelectedAttributesCount = (selected: SelectedAttributes): number =>
  Object.values(selected).reduce((total, values) => total + values.length, 0);
